<div class="download-container">
  <ng-container [ngSwitch]="true">
    <div
      class="img"
      *ngSwitchCase="
            data?.fileBase64?.fileExtension === 'png' ||
            data?.fileBase64?.fileExtension === 'jpg' ||
            data?.fileBase64?.fileExtension === 'gif'
          "
    >
      <img [src]="imageSrc" alt="" />
      <span>{{ data?.fileBase64?.fileName }}</span>
    </div>

    <div class="doc" *ngSwitchDefault>
      <i
        *ngIf="
              !data?.fileBase64?.fileType ||
              data?.fileBase64?.fileType === 'doc'
            "
        class="icon-link pi pi-external-link"
      ></i>
      <i
        *ngIf="data?.fileBase64?.fileType === 'sign'"
        class="icon-link pi pi-check-circle"
      ></i>
      <i
        *ngIf="data?.fileBase64?.fileType === 'arch'"
        class="icon-link pi pi-inbox"
      ></i>
      <span>{{ data?.fileBase64?.fileName }}</span>
    </div>
  </ng-container>
</div>
<div class="buttons">
  <button
    pButton
    label="{{ 'BUTTON_DOWNLOAD' | translate }}"
    icon="pi pi-download"
    iconPos="left"
    class="button"
    (click)="downloadImg()"
  ></button>
  <button
    pButton
    class="button p-button-outlined"
    label="{{ 'BUTTON_CLOSE' | translate }}"
    (click)="onCloseDialog()"
  ></button>
</div>
